<template>
<div class="dboard-card">
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div class="row" v-else>
    <div class="col-lg-12">
      <div class="dboard-card-panel">
        <!-- <div class="doughnut dsplinline-left">
          <vue-circle
            :progress="delayedPercent"
            :size="100"
            :reverse="false"
            line-cap="round"
            :fill="fill"
            empty-fill="#55606D"
            :animation-start-value="0.0"
            :start-angle="startAngle"
            insert-mode="append"
            :thickness="8"
            :show-percent="true">
          </vue-circle>
        </div> -->
        <div class="dboard-card-panel-section dsplinline chart">
          <div class="dboard-card-section-secnumber tertiary-text">
            {{count.delayed}}
          </div>
          <div class="dboard-card-section-sectitle primary-text">
            Delayed
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
// import VueCircle from 'vue2-circle-progress';

export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    }
  },
  // components: {
  //   VueCircle,
  // },
  data() {
    return {
      fill: { color: '#E8655D' },
      startAngle: -Math.PI / 2,
    };
  },
  computed: {
    delayedPercent() {
      return (this.count.delayed / this.count.dispatched) * 100;
    }
  }
};
</script>
<style>
  .percent-text {
    color: #E5DDF2;
    font-size: 20px !important;
    text-align: center;
    margin-left: 10px;
  }
  .vue-progress-path {
    margin-left: 150px;
  }
</style>
